import DefaultModal from '@/src/common/components/marketing/modals/DefaultModal'
import StonlyContent from '@/src/common/components/marketing/modals/StonlyContent'

interface IStonlyModal {
    showModal: boolean
    setShowModal: Function
}

const StonlyContentModal = ({ showModal, setShowModal }: IStonlyModal) => {
    return (
        <DefaultModal
            showModal={showModal}
            setShowModal={setShowModal}
            testId={'ways-to-use-modal'}
            width={'large'}
            height={'90vh'}
            variant={'iframe'}
        >
            <StonlyContent />
        </DefaultModal>
    )
}

export default StonlyContentModal
